import Navbar from '../components/Navbar'
import Footer from '../components/Footer'
import '../pages/styling/blog.scss'
import Anthology from '../assets/blog/anthology.jpg'
import Ordinary from '../assets/blog/ordinary.jpg'
import Woven from '../assets/blog/woven.jpg'
import CarouselPeople from '../components/CarouselPeople'
import CarouselGallery from '../components/CarouselGallery'
import PeopleSlides from '../data/carouselDataPeople'
import GallerySlides from '../data/carouselDataGallery'
import party from '../assets/blog/party.jpg'
import van from '../assets/blog/van.jpg'
import certificate2 from '../assets/blog/certificate2.jpg'
import certificate3 from '../assets/blog/certificate3.jpg'
import pressRelease from '../assets/blog/pressRelease.png'
import Arthub from '../assets/blog/arthub.jpg'
import Programme from '../assets/blog/newleaflet.jpg'


export default function Blog() {
  return (
    <div className='container'>
      <Navbar />
        <div id='blog'>
        <h1 className='blogTitle'>Our Blog</h1>
        <section className="press-release-section">
          <div className="press-release-card">
            <span className="press-badge">Latest News</span>
            <h1 className="press-title">Serendipity Creative Writers Charity Secures Space for New Arts Hub</h1>
            <p className="press-date">Published: July 2026</p>

            <div className="press-body">
              <p>
                <strong>Serendipity Creative Writers Charity</strong>, a creative writing group set up in 2018 to help people with mental health challenges across Kirklees, has secured a prime town centre location to be used as a Creative Arts Hub.
              </p>

              <p>
                Sonia Zoref, founder of Serendipity, secured the space after a tough application process and competitive interest from other worthy charities.
              </p>

              <div className="press-quote">
                <p>
                  "The Creative Arts Hub will allow us to provide a safe space to help even more people who are living with mental health challenges, as well as running the Huddersfield Creative Writers group and other partnership projects."
                </p>
                <cite>— Sonia Zoref, Founder</cite>
              </div>

              <p>
                Sonia’s vision is to create a space where members are able to display their artwork, deliver upcycling workshops, and have a clothes swap. The Hub will allow the strong partnerships that Serendipity has with other voluntary and community organisations to grow from strength to strength, including the Vibe Singing Group which is run in collaboration with Her Space Evenings in Huddersfield. These are just some of the ideas that Serendipity has about how the Hub can be utilised for the full benefit of the community.
              </p>

              <div className="press-quote">
                <p>
                  "Serendipity came into my life at a point where there was a lot of change and uncertainty. I had lost my identity and was unsure of my next steps. As well as encouraging a love of writing to help me through those tricky times, Serendipity has given me a sense of acceptance and belonging."
                </p>
                <cite>— Gemma Blagbrough, Member and Trustee</cite>
              </div>

              <div className="launch-details-box">
                <h3>Official Launch Event</h3>
                <p><strong>Date & Time:</strong> Saturday 12th September 2026, 4:00pm – 6:00pm</p>
                <p><strong>Location:</strong> Serendipity Arts Hub, 23 Market Place, Huddersfield, HD1 2AA</p>
              </div>
            </div>
          </div>
        </section>
        <section className='locations'>
        <h1 className='locationsTitle'>Our Publications</h1>
        <p className='locationsDescription'>Check out our anthologies</p>
        <div className="row">
          <div className="classLocation">
            <img src={Anthology} alt='Anthology'/>
            <div className="layer">
              <h3>A Serendipitous Handthology</h3>
            </div>
          </div>
          <div className="classLocation">
            <img src={Ordinary} alt='Ordinary'/>
            <div className="layer">
              <h3>Extrordinary Ordinary</h3>
            </div>
          </div>
          <div className="classLocation">
            <img src={Woven} alt='Woven'/>
            <div className="layer">
              <h3>Woven</h3>
            </div>
          </div>
        </div>
      </section>
      <section className="feedback-section">
        <div className="feedback-container">
          <h2 className="feedback-main-title">Serendipity Creative Writers Group Charity & Arts Hub</h2>
          <span className="feedback-sub-badge">(Registered Charity No. 1201197)</span>

          <p className="feedback-intro">
            At Serendipity, the staff, trustees and volunteers are committed to improving the services we provide including providing new services, workshops and events. We continually engage with our current service users and the general public in and around Kirklees by talking to people, asking for feedback and testimonies so we can be the very best at what we do.
          </p>

          <div className="feedback-header-box">
            <h2>YOU ASKED – WE DID</h2>
            <span className="feedback-date">July 2026</span>
          </div>

          <div className="feedback-grid">
            {/* Pair 1 */}
            <div className="feedback-row">
              <div className="asked-card">
                <span className="card-label">You Asked</span>
                <p><strong>GB, Huddersfield:</strong> “I would love to be part of the Creative Writing, but I work through the day, could you do an evening workshop?”</p>
              </div>
              <div className="did-card">
                <span className="card-label">We Did</span>
                <p><strong>SCW:</strong> “We now have an evening Creative Writing workshop in the centre of Huddersfield that has easy access from both the bus and train stations and free roadside parking.”</p>
              </div>
            </div>

            {/* Pair 2 */}
            <div className="feedback-row">
              <div className="asked-card">
                <span className="card-label">You Asked</span>
                <p><strong>RH, Dewsbury:</strong> “I would love to team up the writing we do with SWC with other creative arts i.e. painting/drawing.”</p>
              </div>
              <div className="did-card">
                <span className="card-label">We Did</span>
                <p><strong>SCW:</strong> “We have now developed a new Painting workshop as one of our many activities in the new Arts Hub. As we have many creatives, we will be working towards projects by using both mediums in our next Poetry Anthology, and other projects such as the 2027 calendar.”</p>
              </div>
            </div>

            {/* Pair 3 */}
            <div className="feedback-row">
              <div className="asked-card">
                <span className="card-label">You Asked</span>
                <p><strong>NW, Batley:</strong> “It would be great to have an Arts space where there is an opportunity to be involved in lots of creative projects. I like sewing, and would be interested in upcycling clothes.”</p>
              </div>
              <div className="did-card">
                <span className="card-label">We Did</span>
                <p><strong>SCW:</strong> “Our new Arts Hub will be running upcycling workshops for clothes, furniture etc. We will be collaborating with other local community groups who will be facilitating arts and crafts through recycling.”</p>
              </div>
            </div>

            {/* Pair 4 */}
            <div className="feedback-row">
              <div className="asked-card">
                <span className="card-label">You Asked</span>
                <p><strong>CZ, Huddersfield:</strong> “I think it would be beneficial for our Community to have more open mic events like poetry, music, singing.”</p>
              </div>
              <div className="did-card">
                <span className="card-label">We Did</span>
                <p><strong>SCW:</strong> “Our new Arts Hub will be a venue buzzing with lots of new and exciting creative activities. We are planning additional open mic events that will suit all our existing service users, and attract new people.”</p>
              </div>
            </div>

            {/* Pair 5 */}
            <div className="feedback-row">
              <div className="asked-card">
                <span className="card-label">You Asked</span>
                <p><strong>RW, Huddersfield:</strong> “Huddersfield needs a singing group that’s easily accessible.”</p>
              </div>
              <div className="did-card">
                <span className="card-label">We Did</span>
                <p><strong>SCW:</strong> “Welcome to VIBE, our new fortnightly singing group in Huddersfield centre.”</p>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className='celebs'>
        <h1 className='celebsTitle'>Gallery</h1>
        <p className='carouselDescription'>Have a look at some of our events & groups</p>
        <div className='celebspics'>
          <img src={certificate2} alt='certificate' className='celebSidePic'/>
          <CarouselGallery className='carousel' data={GallerySlides} />
          <img src={party} alt='party' className='celebSidePic'/>
        </div>
      </section>
      <section className='nationalLottery'>
        <h1 className='natLotTitle'>National Lottery</h1>
        <p className='natLotDescription'>Check out our press release for the National Lottery funding</p>
        <div className='pressLetterImage'>
          <img src={pressRelease} alt='pressReleaseLetter'/>
        </div>
      </section>
        <section className='celebs'>
        <h1 className='celebsTitle'>People we've met</h1>
        <p className='carouselDescription'>Check out some celebs we've met</p>
        <div className='celebspics'>
          <img src={van} alt='van' className='celebSidePic'/>
          <CarouselPeople className='carousel' data={PeopleSlides} />
          <img src={certificate3} alt='certificate' className='celebSidePic'/>
        </div>
      </section>
      <section className="leaflet-container">
        <img src={Arthub} alt="Leaflet Arthub" className="leaflet-img" />
        <img src={Programme} alt="Leaflet Programme" className="leaflet-img" />
      </section>
      <section className='funders'>
        <h1 className='fundersTitle'>Funders & Partnerships</h1>
        <p className='fundersDescription'>See who we work & partner with:</p>
          <ul className='fundersList'>
            <li className='fundersListItem'>The DebsEffect </li>
            <li className='fundersListItem'>LEAP</li>
            <li className='fundersListItem'>SWYPT NHS TRUST</li>
            <li className='fundersListItem'>CLIMB25</li>
            <li className='fundersListItem'>Phone Box Gallery Heckmondwike</li>
            <li className='fundersListItem'>WOVEN</li>
            <li className='fundersListItem'>Third Sector Leaders, Huddersfield</li>
            <li className='fundersListItem'>Community Plus</li>
            <li className='fundersListItem'>One Community</li>
            <li className='fundersListItem'>The KRYPT</li>
            <li className='fundersListItem'>The National Lottery</li>
            <li className='fundersListItem'>Arnold Clark</li>
            <li className='fundersListItem'>The Jimmy Dickinson Foundation</li>
            <li className='fundersListItem'>The Mayors Safer Communities</li>
            <li className='fundersListItem'>The Cheshire Community Foundation</li>
            <li className='fundersListItem'>Locala</li>
            <li className='fundersListItem'>Magic Little Grants</li>
            <li className='fundersListItem'>Comic Relief</li>
            <li className='fundersListItem'>The West Yorkshire Health & Care Partnership</li>
            <li className='fundersListItem'>The Jo Cox Foundation</li>
            <li className='fundersListItem'>The Full Circle Café, Huddersfield</li>
            <li className='fundersListItem'>Hive Community Café, Huddersfield</li>
            <li className='fundersListItem'>The Crescent CIC, Batley</li>
            <li className='fundersListItem'>Cloggs Community Café, Dewsbury</li>
            <li className='fundersListItem'>Ability Options</li>
            <li className='fundersListItem'>Huddersfield Literature Festival</li>
            <li className='fundersListItem'>The University of Huddersfield</li>
            <li className='fundersListItem'>Marsden Poets</li>
            <li className='fundersListItem'>Batley Poets</li>
            <li className='fundersListItem'>The Albert Poets</li>
            <li className='fundersListItem'>Kirklees Council</li>
            <li className='fundersListItem'>Kirklees Libraries</li>
            <li className='fundersListItem'>St. John Ambulance</li>
            <li className='fundersListItem'>Folly Hall Mental Health Services, Huddersfield</li>
            <li className='fundersListItem'>HerSpace</li>
            <li className='fundersListItem'>Cafe Life</li>
            <li className='fundersListItem'>The Sweet Affair Cafe</li>
            <li className='fundersListItem'>Elephants are Scared of Bees</li>
            <li className='fundersListItem'>The Lipstick Project</li>
            <li className='fundersListItem'>Platform 1</li>
            <li className='fundersListItem'>Emerging Futures</li>
          </ul>
        </section>
        </div>
      <Footer />
    </div>
  )
}
